<template>
  <div class="page-wrapper p-done center-md">

    <menu-co></menu-co>

    <div class="pure-g halt-lg padding-md lobby-boxes">
      <div class="lobby-content smaller pure-u-1-1">
        <h2 class="icon i-clover-blue">{{ $lang.done.header }}</h2>
        <div class="chunk-style top-margin" v-html="$lang.done.text"></div>
        <a class="btn green" href="">{{ $lang.done.button }}</a>
      </div>
    </div>

  </div>
</template>

<script>
  import Menu from '../../../components/menu/'
  import dataOption from '../../../assets/data/staticdata.json'
  import dataContext from '../../../assets/data/context.json'

  export default {
    name: 'case-done',
    data () {
      return {
        context: '',
        dataOption: dataOption,
        dataContext: dataContext,
        correctDone: ''
      }
    },
    props: ['props'],
    beforeMount () {
      this.context = this.store.getItem(this.dataContext.current_context)
    },
    mounted () {
      this.$nextTick(function () {
        window.scrollTo(0, 0)
      })
      this.util.addBodyClass('beige-bg')
    },
    beforeDestroy () {
      this.util.removeBodyClass('beige-bg')
    },
    components: {
      'menu-co': Menu
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/content/done/index.vue